import {Tag} from 'antd';
import {ROLE_TAG_COLOR} from '../Constants';
import React from 'react';

export interface UserLimitCountProps {
	operatorRoleCount: number;
	basicRoleCount: number;
	operatorplusRoleCount: number;
	operatorMaxRoles: number;
	basicMaxRoles: number;
	operatorplusMaxRoles: number;
}

export function UserLimitCount(props: Readonly<UserLimitCountProps>): React.JSX.Element {
	return (
		<>
			{props.operatorplusMaxRoles > 0 ? (
				<Tag color={ROLE_TAG_COLOR.OPERATORPLUS} style={{padding: '5px'}}>
					OperatorPlus Users: {props.operatorplusRoleCount}/{props.operatorplusMaxRoles}
				</Tag>
			) : null}

			<Tag color={ROLE_TAG_COLOR.OPERATOR} style={{padding: '5px'}}>
				Operator Users: {props.operatorRoleCount}/{props.operatorMaxRoles}
			</Tag>
			<Tag color={ROLE_TAG_COLOR.BASIC} style={{padding: '5px'}}>
				Basic Users: {props.basicRoleCount}/{props.basicMaxRoles}
			</Tag>
		</>
	);
}
